/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSession} from '../api'

 export const useQueryGetSession = createReactQueryHook('getSession', getSession)
